import 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import logEvent from './helpers'
const rawUrlTemplate = `https://storage.cloud.google.com/our-assets.appspot.com/`
const urlTemplate = `https://storage.cloud.google.com/our-assets.appspot.com/images/`
const ItemModule = {
  firestorePath: 'items',
  firestoreRefType: 'collection',
  moduleName: 'ItemModule',
  statePropName: 'items',
  namespaced: true,
  sync: {
    defaultValues: {
      name: '',
      description: '',
      galleryRef: '',
      value: 0,
      archived: false,
      deleted: false,
      photos: [],
      tags: [],
      dirty: false,
      data: '',
      photoUrl: '',
      thumbUrl: '',
      selected: false
    },
    guard: ['dirty']
  },
  getters: {
    get: (state) => {
      let items = Object.values(state.items).filter(item => !item.archived)
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        item.photoUrl = item.data
        // console.log(item)
        if (!item.data.includes('.jpg') && !item.data.includes('640x640') && !item.data.includes('290x290')) {
          var photoId = item.data.replace(/^.+?\/images\//, "")
            photoId = photoId.replace(/_.+?.jpeg$/, "")
            items[i].photoUrl = `${urlTemplate}${photoId}_640x640.jpeg`
            items[i].data = `${urlTemplate}${photoId}_290x290.jpeg`
            items[i].fullSizeUrl = `${rawUrlTemplate}${photoId}.jpg`
        }
      }

      return items
    },
    getArchived: (state) => {
      let items = Object.values(state.items).filter(item => item.archived)
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        item.photoUrl = item.data
        // console.log(item)
        if (!item.data.includes('.jpg') && !item.data.includes('640x640') && !item.data.includes('290x290')) {
          var photoId = item.data.replace(/^.+?\/images\//, "")
            photoId = photoId.replace(/_.+?.jpeg$/, "")
            items[i].photoUrl = `${urlTemplate}${photoId}_640x640.jpeg`
            items[i].data = `${urlTemplate}${photoId}_290x290.jpeg`
            items[i].fullSizeUrl = `${rawUrlTemplate}${photoId}.jpg`
        }
      }

      return items
    },
    getById: (state) => (id) => {
      var items = Object.values(state.items)
      var item = {name: '', description: '', value: 0}
      for (var i = 0; i < items.length; i++) {
        item = items[i]
        if (item.id === id) {

          if (!item.data.includes('.jpg') && !item.data.includes('640x640') && !item.data.includes('290x290')) {
            var photoId = item.data.replace(/^.+?\/images\//, "")
            photoId = photoId.replace(/_.+?.jpeg$/, "")
            items[i].photoUrl = `${urlTemplate}${photoId}_640x640.jpeg`
            items[i].data = `${urlTemplate}${photoId}_290x290.jpeg`
            items[i].fullSizeUrl = `${rawUrlTemplate}${photoId}.jpg`
          }
          break
        }
      }

      return item
    },
    getByTag: (state) => (tag) => {
      return Object.values(state.items).filter(item => item.tags.includes(tag))
    }
  },
  actions: {
    create: ({dispatch}, payload) => {
      var item = {
        name: payload.name,
        value: payload.value,
        created_by: payload.created_by,
        description: '',
        galleryRef: '',
        archived: false,
        photos: [],
        tags: [],
        dirty: false,
        data: '',
        photoUrl: '',
        thumbUrl: '',
        deleted: false
      }

      logEvent({event: 'new_item', item_name: payload.id, item_value: payload.value})
      return dispatch('insert', item)
    },
    updateOwner: ({dispatch}, payload) => {
      dispatch('patch', {id: payload.id, created_by: payload.created_by})
    },
    setUrl: ({dispatch}, payload) => {
      var item = {
        id: payload.id,
        data: payload.data
      }

      dispatch('patch', item)
    },
    save: ({dispatch}, payload) => {
      var item = {
        id: payload.id,
        name: payload.name,
        value: payload.value,
        description: payload.description,
        deleted: false
      }

      logEvent({event: 'update_item', item_name: payload.id, item_value: payload.value})
      dispatch('patch', item)
    },
    permadelete: ({dispatch}, payload) => {
      logEvent({event: 'delete_item', item_name: payload.id})
      dispatch('patch', {id: payload.id, deleted: true})
    },
    archive: ({dispatch}, payload) => {
      logEvent({event: 'archive_item', item_name: payload.id})
      dispatch('patch', {id: payload.id, archived: !payload.archived})
    },
    savePhotoOrder: ({dispatch}, payload) => {
      dispatch('patch', {id: payload.id, photos: payload.photos})
    },
    addPhoto: ({dispatch}, payload) => {
      // console.log(payload)
      logEvent({event: 'new_photo', photo_id: payload.id})
      dispatch('patch', {id: payload.id, photos: payload.photos})
    },
    removePhoto: ({dispatch}, payload) => {
      var index = payload.item.photos.indexOf(payload.photoId)
      payload.item.photos.splice(index, 1)

      dispatch('patch', {id: payload.item.id, photos: payload.item.photos})
    },
    setTags: ({dispatch}, payload) => {
      logEvent({event: 'tag_item', item_name: payload.id, 'tag_list': payload.tags.toString()})
      dispatch('patch', {id: payload.id, tags: payload.tags})
    }
  }
}

export default ItemModule